import { z } from 'zod';
import '@apexdesigner/schema-tools';

export const horseMeasurements = z
  .object({
    height: z.number().describe('1. Height at the withers.'),

    heartGirth: z.number().describe('2. Heart girth.'),

    length: z.number().describe('3. Length.'),

    flank: z.number().describe('4. Flank.'),

    frontLeg: z.number().describe('5. Front leg.'),

    backPastern: z.number().describe('6. Back pastern.'),

    frontPastern: z.number().describe('7. Front pastern.'),

    back: z.number().describe('8. Back.'),

    hipToHock: z.number().describe('9. Hip to hock.'),

    hockToGround: z.number().describe('10. Hock to ground.'),

    ilium: z.number().describe('11. Ilium.'),

    tuberCalcis: z.number().describe('12. Tuber calcis.'),

    gaskin: z.number().describe('13. Gaskin.'),

    tibia: z.number().describe('14. Tibia.'),

    femur: z.number().describe('15. Femur.'),

    bodyLength: z.number().describe('16. Body length.'),
  })
  .describe(
    'The 16 body measurements of one horse, with the same names and order as on the horse. A match keeps a copy for each parent as the calculation read them, and the calculation takes this as its input.',
  )
  .as('HorseMeasurements', { embedded: true });

export { horseMeasurements as horseMeasurementsSchema };
